'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("circle", {
    id: "realty-type-house_svg__a",
    cx: 28,
    cy: 28,
    r: 28
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "realty-type-house_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#realty-type-house_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#F58F4B",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 56)",
    xlinkHref: "#realty-type-house_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#realty-type-house_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M24.365 12.805c0 6.67-5.406 12.076-12.076 12.076-6.67 0-12.076-5.406-12.076-12.076C.213 6.135 5.62.729 12.289.729c6.67 0 12.076 5.406 12.076 12.076",
    fill: "#3F3E4B",
    opacity: 0.2,
    style: {
      mixBlendMode: 'multiply'
    },
    transform: "translate(12 12.889)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFFFFE",
    d: "M17.352 26.465h3.083v-6.167h-3.083z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M20.949 19.784h-4.111v7.195h4.11v-7.195Zm-1.028 1.028v5.139h-2.055v-5.139h2.055Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.338 42.395H14.782V31.341c4.625-3.98 6.536-6.418 10.516-10.529h.092c3.98 4.111 6.35 6.548 9.948 10.529v11.054",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M25.608 20.298h-.527l-.562.582-.613.641-.636.673-2.537 2.71-.615.65-.396.412a73.385 73.385 0 0 1-4.88 4.643l-.574.496V42.91h21.584V31.143l-.537-.593-.788-.866-.767-.835-.754-.815-.75-.804-.97-1.03-1.861-1.953-3.817-3.949Zm-.263 1.206 4.158 4.311 1.037 1.091.967 1.027.746.8.375.405.756.82.774.847.666.734V41.88H15.296V31.576l-.178.154a74.885 74.885 0 0 0 5.345-5.05l.605-.634 2.95-3.147.836-.884.49-.511Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "m25.06 22.867 10.278 10.278 2.055-2.055L25.06 18.756 12.727 31.09l2.055 2.055L25.06 22.867"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.12 31.09 25.06 18.03 12 31.09l2.782 2.782L25.06 23.595l10.278 10.277 2.782-2.782ZM25.06 19.484 36.666 31.09l-1.328 1.328L25.06 22.141 14.782 32.418l-1.328-1.328L25.06 19.484Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#E9EAE6",
    d: "M17.866 42.395h4.11v-7.708h-4.11z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.49 34.173h-5.138v8.736h5.139v-8.736ZM21.464 35.2v6.68h-3.084v-6.68h3.084Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFFFFE",
    d: "M24.032 38.798h4.625v-4.111h-4.625z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.171 34.173h-5.653v5.139h5.653v-5.14ZM28.143 35.2v3.083h-3.597v-3.083h3.597Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.215 42.395c.243-6.684 6.29-7.965 6.29-13.135 0-3.959-3.457-7.151-7.517-6.641-3.47.436-6.033 3.648-5.775 7.136.355 4.799 6.037 6.433 6.272 12.64h.73",
    fill: "#BFBEC8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M33.924 22.109c-3.729.468-6.502 3.91-6.224 7.683.13 1.763.817 3.074 2.33 4.927l.92 1.099.336.405c1.838 2.257 2.596 3.825 2.685 6.192l.019.494h1.72l.019-.495c.093-2.553.907-4.194 2.849-6.51l1.01-1.183c1.705-2.023 2.43-3.447 2.43-5.461 0-4.263-3.684-7.614-7.942-7.169l-.152.018Zm7.066 7.15c0 1.607-.547 2.784-1.897 4.448l-.326.393-.802.937-.171.203c-1.626 1.937-2.537 3.48-2.906 5.411l-.042.238c-.342-1.938-1.247-3.482-2.926-5.513l-.94-1.12c-1.5-1.806-2.14-2.982-2.255-4.54-.238-3.23 2.145-6.188 5.327-6.587 3.705-.466 6.938 2.432 6.938 6.13Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M36.869 29.26a2.02 2.02 0 1 1-4.04 0 2.02 2.02 0 0 1 4.04 0",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M34.85 26.726a2.533 2.533 0 1 0 0 5.066 2.533 2.533 0 0 0 0-5.066Zm0 1.028a1.505 1.505 0 1 1 0 3.01 1.505 1.505 0 0 1 0-3.01Z",
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "#3F3E4B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.234 13.423c1.407 0 2.44.788 2.684 2.145l.016.105h1.64v1.028h-2.626l-.003-.51c-.008-1.148-.65-1.74-1.71-1.74-.597 0-1.115.272-1.42.73l-.055.087-.17.293-.336-.04c-.728-.089-1.15.114-1.397.745l-.033.089-.12.346h-3.436v-1.028h2.728l.047-.092c.413-.768 1.1-1.123 1.98-1.106l.032.001.024-.031a2.7 2.7 0 0 1 2.026-1.019l.13-.003ZM40.99 18.756v1.028h-6.68v-1.028zM33.282 18.756v1.028h-1.028v-1.028zM31.227 18.756v1.028h-1.028v-1.028zM36.07 12.889c1.475 0 2.907 1.376 3.258 2.706l.018.078h3.7v1.028h-4.663l-.002-.513c-.002-.933-1.208-2.271-2.312-2.271-.92 0-1.754.582-2.12 1.437l-.042.104-.185.493-.488-.196a1.226 1.226 0 0 0-.455-.098c-.421 0-.869.299-1.102.686l-.044.078-.143.28H29.17v-1.028h1.716c.406-.578 1.07-1 1.78-1.04l.112-.004c.094 0 .188.007.282.02l.081.015.02-.036c.563-1.009 1.609-1.69 2.777-1.736l.13-.003ZM28.143 15.673v1.028h-1.027v-1.028z"
  })))));
});
var RealtyTypeHouse = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.RealtyTypeHouse = RealtyTypeHouse;